import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectBuildingCompletionYear = createSelector(selectJsonQuery, jsonQuery =>
  getTermsValue('year')(jsonQuery),
);
